// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "js/sh" + "-" + __webpack_require__.h() + ".css";
};